module.exports = __webpack_public_path__ + "static/media/kajal-ahirwal.9d45f3ad.png";